module.exports = __webpack_public_path__ + "img/lpfv-sp-5000.97a12ce6.png";